/**
 * Broker roster for SterlingCRE Prospect + Nurture app.
 * Names must match exactly how they appear in Monday.com's person column.
 * email: the Google Workspace username prefix (before @sterlingcreadvisors.com)
 * isAdmin: grants admin/supervisor access when that view is built
 * Add or remove brokers here as the team changes.
 */
export const BROKERS = [
  { name: 'Matt Mellott',    initials: 'MM', email: 'matt',          isAdmin: true  },
  { name: 'Claire Matten',   initials: 'CM', email: 'claire',        isAdmin: false },
  { name: 'Connor McMahon',  initials: 'CM', email: 'connor',        isAdmin: false },
  { name: 'Joe Tredik',      initials: 'JT', email: 'joe.tredik',    isAdmin: false },
  { name: 'Dean Wilson',     initials: 'DW', email: 'dean.wilson',   isAdmin: false },
  { name: 'Kara Hogan',      initials: 'KH', email: 'kara.hogan',    isAdmin: false },
  { name: 'Sierra Pierce',   initials: 'SP', email: 'sierra.pierce', isAdmin: false },
  { name: 'Sara Townsley',   initials: 'ST', email: 'sara',          isAdmin: true  },
];

export const STORAGE_KEY = 'sterling_broker';
